var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockArrowIndent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4669_46354",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.415039H14.8936L20 6.00015L14.8936 11.5853H0L4.46809 6.00015L0 0.415039Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.415039V-1.08496H-3.12094L-1.1713 1.35208L0 0.415039ZM14.8936 0.415039L16.0007 -0.597115L15.5546 -1.08496H14.8936V0.415039ZM14.8936 11.5853V13.0853H15.5546L16.0007 12.5974L14.8936 11.5853ZM0 11.5853L-1.1713 10.6482L-3.12094 13.0853H0V11.5853ZM20 6.00015L21.107 7.0123L22.0324 6.00015L21.107 4.98799L20 6.00015ZM4.46809 6.00015L5.63939 6.93719L6.38902 6.00015L5.63939 5.0631L4.46809 6.00015ZM0 1.91504H14.8936V-1.08496H0V1.91504ZM14.8936 10.0853H0V13.0853H14.8936V10.0853ZM13.7866 1.42719L18.893 7.0123L21.107 4.98799L16.0007 -0.597115L13.7866 1.42719ZM18.893 4.98799L13.7866 10.5731L16.0007 12.5974L21.107 7.0123L18.893 4.98799ZM1.1713 12.5223L5.63939 6.93719L3.29678 5.0631L-1.1713 10.6482L1.1713 12.5223ZM5.63939 5.0631L1.1713 -0.522004L-1.1713 1.35208L3.29678 6.93719L5.63939 5.0631Z",
    fill: "#2B2B35",
    mask: "url(#path-1-inside-1_4669_46354)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockArrowIndent);
export default __webpack_public_path__ + "static/media/block_arrow_indent.e81290d9a55a16d3c9c74be72893a009.svg";
export { ForwardRef as ReactComponent };